export default function ListSubheader({ children }) {
  return (
    <div className="text-purple-400 uppercase font-medium text-xs">
      {children}
    </div>
  )
}
